import { rem } from 'polished';
import styled from 'styled-components';

export const Background = styled.div`
    background: ${({ theme }) => theme.colors.greyLight};
    padding: 0 ${rem(40)};
`;

export const Persons = styled.div`
    padding: ${rem(40)} 0 ${rem(20)} 0;
    display: flex;
    flex-wrap: wrap;
    gap: 3%;
`;
